import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-jjsv-notification',
  imports: [],
  templateUrl: './jjsv-notification.component.html',
  styleUrl: './jjsv-notification.component.scss',
})
export class JjsvNotification {
  @Input() content: { title: string; message: string; notificationStatus: string } = { title: '', message: '', notificationStatus: '' };
}
